export enum AppErrorType {
  General = 'General',
  Critical = 'Critical',
}
